var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"angle-selector"},[_c('div',{ref:"circle",staticClass:"circle",on:{"click":_vm.circleClicked}},[_c('div',{staticClass:"c-pointer",style:({'transform':`rotate(${_vm.closeWise?_vm.angle:-_vm.angle}deg)`}),on:{"mousedown":_vm.mousedownHandle}},[_c('div',{staticClass:"c-center"}),_c('div',{staticClass:"c-line"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }